export default "__VITE_ASSET__BQCGTThC__";